import React, { SetStateAction, useState } from "react";
import { FaChevronDown } from "react-icons/fa";

const zoomOptions = [50, 75, 100, 125, 150, "Fit to screen"];
function ZoomDropdown({
  containerRef,
  setScale,
}: {
  containerRef: React.RefObject<HTMLDivElement>;
  setScale: React.Dispatch<SetStateAction<number>>;
}) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [activeZoom, setActiveZoom] = useState("100%");

  const handleZoomSelect = (option: string | number) => {
    if (option === "Fit to screen") {
      if (containerRef.current) {
        const width = containerRef.current.offsetWidth;
        setScale(width / 800); // Assuming 800 is base PDF width
        setActiveZoom("Fit to screen");
      }
    } else {
      // @ts-expect-error
      setScale(option / 100);
      setActiveZoom(`${option}%`);
    }
    setShowDropdown(false);
  };
  return (
    <div className="relative">
      <button
        className="w-[8vw] h-[6vh] text-sm gap-x-1 flex items-center border-2 justify-center shadow-border rounded-lg"
        onClick={() => setShowDropdown((previous) => !previous)}
        type="button"
      >
        <span>{activeZoom}</span>
        <FaChevronDown size={10} />
      </button>

      {showDropdown && (
        <div className="absolute z-10 mt-2 bg-white shadow-md rounded-lg border w-[10vw] text-sm">
          {zoomOptions.map((option) => (
            <div
              className="cursor-pointer px-3 py-2 hover:bg-gray-100"
              key={option}
              onClick={() => handleZoomSelect(option)}
            >
              {typeof option === "number" ? `${option}` : option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ZoomDropdown;
